/* Whiskey WeekEnder — icon animation triggers.
   Adds .is-in once when an icon is ≥40% in view (entrance animations) and
   toggles .is-visible while any of it is on screen (loops pause off-screen).
   Honours prefers-reduced-motion by jumping straight to the finished state.
   Re-runs for sections (re)loaded in the Shopify theme editor. */
(function () {
  if (window.__wkAnim) return;
  window.__wkAnim = true;

  document.documentElement.classList.add('wk-js');

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var enter = null;
  var visible = null;

  function finish(el) {
    el.classList.add('is-in', 'is-visible');
  }

  function init(scope) {
    var els = (scope || document).querySelectorAll('[data-wk-anim]:not([data-wk-init])');
    if (!els.length) return;

    var skip = (reduce && reduce.matches) || !('IntersectionObserver' in window);
    if (skip) {
      els.forEach(function (el) { el.setAttribute('data-wk-init', ''); finish(el); });
      return;
    }

    if (!enter) {
      enter = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            enter.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });

      visible = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle('is-visible', e.isIntersecting);
        });
      }, { threshold: 0.05 });
    }

    els.forEach(function (el) {
      el.setAttribute('data-wk-init', '');
      enter.observe(el);
      visible.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (reduce && reduce.addEventListener) {
    reduce.addEventListener('change', function () {
      if (reduce.matches) document.querySelectorAll('[data-wk-anim]').forEach(finish);
    });
  }
})();
